var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CoreBlock',{class:_vm.$style.comparisonTable,attrs:{"block":{..._vm.block, innerHtml: _vm.getTableWithReplacedImage(_vm.block.innerHtml)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }